"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SecondaryNavIdentifier = exports.PrimaryNavIdentifier = exports.FeatureFlagsProductType = void 0;

/**
 *  MODAL
 */
var OPEN_MODAL_EVENT = 'OPEN_MODAL_EVENT';
var MODAL_TYPE_CART = 'CART_MODAL';
var MODAL_TYPE_AUTH = 'AUTH';
var MODAL_TYPE_PUBLISH_REGISTRY = 'PUBLISH_REGISTRY';
var MODAL_TYPE_SET_SHIPPING_ADDRESS = 'SET_SHIPPING_ADDRESS';
var MODAL_TYPE_SHIPPING_EXCLUSION = 'SHIPPING_EXCLUSION';
var MODAL_TYPE_BOOKING_STATUS_REMINDER = 'BOOKING_STATUS_REMINDER'; // NOTE: Dispatched from 'Public Registry (web-registry)'

var PUBLIC_REGISTRY_EVENT = 'PUBLIC_REGISTRY_EVENT';
/**
 *  NAV V2
 */

var NAV_LOADED = 'NAV_LOADED';
/**
 * Custom event payload for indicating that a jewel should be shown on a menu item
 * in the nav. Cab be dispatched by web-** apps
 *
 * @example
 *   window.dispatchEvent(
 *     new CustomEvent<NavJewelEventPayload>(
 *       NAV_JEWEL_CUSTOM_EVENT,
 *       {
 *         detail: { showVendorsJewel: true }
 *       }
 *     )
 *   )
 */

var NAV_JEWEL_CUSTOM_EVENT = 'NAV_JEWEL_CUSTOM_EVENT';
/**
 * Custom event triggered when navigation data is available from a web-product
 * (marketplace/registry/wedding/etc) and the navigation menu needs to know about it
 *
 *
 * @example
 *     window.dispatchEvent(
 *       new CustomEvent(INIT_NAV_DATA, {
 *        detail: {
 *          secondaryData,
 *          userContext,
 *          activePrimaryLink,
 *          activeSecondaryLink,
 *        },
 *      })
 *    );
 *
 * @example
 *    window.dispatchEvent(
 *      new CustomEvent<InitNavDataEventPayload>(INIT_NAV_DATA, {
 *        detail: {
 *          secondaryData,
 *          userContext,
 *          activePrimaryLink,
 *          activeSecondaryLink,
 *        },
 *      })
 *    );
 *
 *  */

var INIT_NAV_DATA = 'INIT_NAV_DATA';
var NAV_PRIMARY_RENDERED = 'NAV_PRIMARY_RENDERED';
var NAV_SECONDARY_RENDERED = 'NAV_SECONDARY_RENDERED';
/**
 * Constants used in web-nav to segment feature flag toggles by product
 */

var FeatureFlagsProductType;
/**
 * The setting for a feature flag, as communicated to web-nav, for a
 * specific product.  For example, this tells web nav the feature flag 'best-feature-ever'
 * is set to true, and its value in production is false.
 */

exports.FeatureFlagsProductType = FeatureFlagsProductType;

(function (FeatureFlagsProductType) {
  FeatureFlagsProductType["WEB_MARKETPLACE"] = "MARKETPLACE";
  FeatureFlagsProductType["WEB_NAV"] = "NAV";
  FeatureFlagsProductType["WEB_WEDDING"] = "WEDDING";
  FeatureFlagsProductType["WEB_REGISTRY"] = "REGISTRY";
  FeatureFlagsProductType["WEB_STORE"] = "STORE";
  FeatureFlagsProductType["WEB_PRE_AUTH"] = "PRE_AUTH";
})(FeatureFlagsProductType || (exports.FeatureFlagsProductType = FeatureFlagsProductType = {}));

/**
 * Custom event for signaling that feature flags are available
 *
 * Custom Event should provide a payload of type FeatureFlagsAvailableEventPayload
 *
 * @example
 *    window.dispatchEvent(
 *      new CustomEvent(FEATURE_FLAGS_AVAILABLE, {
 *        detail: {
 *          domain: FeatureFlagProductType.MARKETPLACE,
 *          flags: [
 *             'best-feature-ever': { value: true, production: false, staging: true, development: false }
 *          ]
 *        },
 *      })
 *    );
 *
 * @example
 *    window.dispatchEvent(
 *      new CustomEvent<FeatureFlagsAvailableEventPayload>(FEATURE_FLAGS_AVAILABLE, {
 *        detail: featureFlagAvailablePayload,
 *      })
 *    );
 *
 */
var FEATURE_FLAGS_AVAILABLE = 'FEATURE_FLAGS_AVAILABLE';
var PrimaryNavIdentifier;
exports.PrimaryNavIdentifier = PrimaryNavIdentifier;

(function (PrimaryNavIdentifier) {
  PrimaryNavIdentifier["REGISTRY"] = "registry";
  PrimaryNavIdentifier["WEBSITE"] = "website";
  PrimaryNavIdentifier["PAPER"] = "invites";
  PrimaryNavIdentifier["ALBUMS"] = "albums";
  PrimaryNavIdentifier["GUEST_LIST"] = "guestList";
  PrimaryNavIdentifier["WEDDING_BOUTIQUE"] = "weddingBoutique";
  PrimaryNavIdentifier["ADVICE"] = "advice";
  PrimaryNavIdentifier["VENDORS"] = "vendors";
  PrimaryNavIdentifier["ACCOUNT"] = "account";
})(PrimaryNavIdentifier || (exports.PrimaryNavIdentifier = PrimaryNavIdentifier = {}));

var SecondaryNavIdentifier;
exports.SecondaryNavIdentifier = SecondaryNavIdentifier;

(function (SecondaryNavIdentifier) {
  SecondaryNavIdentifier["YOUR_REGISTRY"] = "your-registry";
  SecondaryNavIdentifier["NEW_ARRIVALS"] = "new-arrivals";
  SecondaryNavIdentifier["COLLECTIONS"] = "collections";
  SecondaryNavIdentifier["BRANDS"] = "brands";
  SecondaryNavIdentifier["EXPERIENCES"] = "experiences";
  SecondaryNavIdentifier["CASH_FUNDS"] = "cash-funds";
  SecondaryNavIdentifier["SALE"] = "sale";
  SecondaryNavIdentifier["INVITATION"] = "invitations";
  SecondaryNavIdentifier["SAVE_THE_DATE"] = "save-the-date";
  SecondaryNavIdentifier["DIGITAL_SAVE_THE_DATE"] = "digital-save-the-date";
  SecondaryNavIdentifier["CHANGE_THE_DATE"] = "change-the-date";
  SecondaryNavIdentifier["PLACE"] = "place-cards";
  SecondaryNavIdentifier["THANK_YOU"] = "thank-you-cards";
  SecondaryNavIdentifier["MENU"] = "menus";
  SecondaryNavIdentifier["DETAILS"] = "enclosures";
  SecondaryNavIdentifier["PROGRAM"] = "programs";
  SecondaryNavIdentifier["HOLIDAY"] = "holiday-cards";
  SecondaryNavIdentifier["FREE_SAMPLES"] = "free-samples";
  SecondaryNavIdentifier["PROJECTS"] = "projects";
  SecondaryNavIdentifier["ALL_GUESTS"] = "guests";
  SecondaryNavIdentifier["EVENTS"] = "events";
  SecondaryNavIdentifier["BUILD"] = "build";
  SecondaryNavIdentifier["ENVELOPES"] = "envelopes";
  SecondaryNavIdentifier["TRACK_RSVPS"] = "rsvp-overview";
  SecondaryNavIdentifier["RSVP_REQUESTS"] = "rsvp-notifications";
  SecondaryNavIdentifier["SEATING"] = "seating";
  SecondaryNavIdentifier["SUPER_LINK"] = "super-link";
  SecondaryNavIdentifier["MANAGE"] = "manange";
  SecondaryNavIdentifier["EDIT"] = "edit";
  SecondaryNavIdentifier["DESIGNS"] = "designs";
  SecondaryNavIdentifier["CUSTOMIZE"] = "customize";
  SecondaryNavIdentifier["EXPLORE_VENDORS"] = "marketplace-vendors";
  SecondaryNavIdentifier["VENDOR_CONNECTIONS"] = "marketplace-connections";
  SecondaryNavIdentifier["BOOKED_VENDORS"] = "marketplace-booked-vendors";
  SecondaryNavIdentifier["BECOME_VENDOR"] = "marketplace-become-vendor";
  SecondaryNavIdentifier["REAL_WEDDINGS"] = "real-weddings";
  SecondaryNavIdentifier["YOUR_FAVORITES"] = "your-favorites";
})(SecondaryNavIdentifier || (exports.SecondaryNavIdentifier = SecondaryNavIdentifier = {}));

var NAV_DATA = {
  PRIMARY: {
    REGISTRY: PrimaryNavIdentifier.REGISTRY,
    WEBSITE: PrimaryNavIdentifier.WEBSITE,
    PAPER: PrimaryNavIdentifier.PAPER,
    ALBUMS: PrimaryNavIdentifier.ALBUMS,
    GUEST_LIST: PrimaryNavIdentifier.GUEST_LIST,
    WEDDING_BOUTIQUE: PrimaryNavIdentifier.WEDDING_BOUTIQUE,
    ADVICE: PrimaryNavIdentifier.ADVICE,
    VENDORS: PrimaryNavIdentifier.VENDORS,
    ACCOUNT: PrimaryNavIdentifier.ACCOUNT
  },
  SECONDARY: {
    REGISTRY: {
      YOUR_REGISTRY: SecondaryNavIdentifier.YOUR_REGISTRY,
      NEW_ARRIVALS: SecondaryNavIdentifier.NEW_ARRIVALS,
      COLLECTIONS: SecondaryNavIdentifier.COLLECTIONS,
      BRANDS: SecondaryNavIdentifier.BRANDS,
      EXPERIENCES: SecondaryNavIdentifier.EXPERIENCES,
      CASH_FUNDS: SecondaryNavIdentifier.CASH_FUNDS,
      SALE: SecondaryNavIdentifier.SALE
    },
    PAPER: {
      INVITATION: SecondaryNavIdentifier.INVITATION,
      SAVE_THE_DATE: SecondaryNavIdentifier.SAVE_THE_DATE,
      DIGITAL_SAVE_THE_DATE: SecondaryNavIdentifier.DIGITAL_SAVE_THE_DATE,
      CHANGE_THE_DATE: SecondaryNavIdentifier.CHANGE_THE_DATE,
      PLACE: SecondaryNavIdentifier.PLACE,
      THANK_YOU: SecondaryNavIdentifier.THANK_YOU,
      MENU: SecondaryNavIdentifier.MENU,
      DETAILS: SecondaryNavIdentifier.DETAILS,
      PROGRAM: SecondaryNavIdentifier.PROGRAM,
      HOLIDAY: SecondaryNavIdentifier.HOLIDAY,
      FREE_SAMPLES: SecondaryNavIdentifier.FREE_SAMPLES,
      PROJECTS: SecondaryNavIdentifier.PROJECTS,
      YOUR_FAVORITES: SecondaryNavIdentifier.YOUR_FAVORITES
    },
    GUEST_LIST: {
      ALL_GUESTS: SecondaryNavIdentifier.ALL_GUESTS,
      EVENTS: SecondaryNavIdentifier.EVENTS,
      BUILD: SecondaryNavIdentifier.BUILD,
      ENVELOPES: SecondaryNavIdentifier.ENVELOPES,
      TRACK_RSVPS: SecondaryNavIdentifier.TRACK_RSVPS,
      RSVP_REQUESTS: SecondaryNavIdentifier.RSVP_REQUESTS,
      SEATING: SecondaryNavIdentifier.SEATING,
      SUPER_LINK: SecondaryNavIdentifier.SUPER_LINK
    },
    WEBSITE: {
      MANAGE: SecondaryNavIdentifier.MANAGE,
      EDIT: SecondaryNavIdentifier.EDIT,
      CUSTOMIZE: SecondaryNavIdentifier.CUSTOMIZE,
      DESIGNS: SecondaryNavIdentifier.DESIGNS
    },
    MARKETPLACE: {
      EXPLORE_VENDORS: SecondaryNavIdentifier.EXPLORE_VENDORS,
      VENDOR_CONNECTIONS: SecondaryNavIdentifier.VENDOR_CONNECTIONS,
      BOOKED_VENDORS: SecondaryNavIdentifier.BOOKED_VENDORS,
      BECOME_VENDOR: SecondaryNavIdentifier.BECOME_VENDOR,
      REAL_WEDDINGS: SecondaryNavIdentifier.REAL_WEDDINGS,
      YOUR_FAVORITES: SecondaryNavIdentifier.YOUR_FAVORITES
    }
  },
  EVENTS: {
    OPEN_MODAL_EVENT: OPEN_MODAL_EVENT,
    MODAL_TYPE_CART: MODAL_TYPE_CART,
    MODAL_TYPE_AUTH: MODAL_TYPE_AUTH,
    MODAL_TYPE_PUBLISH_REGISTRY: MODAL_TYPE_PUBLISH_REGISTRY,
    MODAL_TYPE_SET_SHIPPING_ADDRESS: MODAL_TYPE_SET_SHIPPING_ADDRESS,
    MODAL_TYPE_SHIPPING_EXCLUSION: MODAL_TYPE_SHIPPING_EXCLUSION,
    MODAL_TYPE_BOOKING_STATUS_REMINDER: MODAL_TYPE_BOOKING_STATUS_REMINDER,
    NAV_LOADED: NAV_LOADED,
    INIT_NAV_DATA: INIT_NAV_DATA,
    PUBLIC_REGISTRY_EVENT: PUBLIC_REGISTRY_EVENT,
    NAV_PRIMARY_RENDERED: NAV_PRIMARY_RENDERED,
    NAV_SECONDARY_RENDERED: NAV_SECONDARY_RENDERED,
    FEATURE_FLAGS_AVAILABLE: FEATURE_FLAGS_AVAILABLE,
    NAV_JEWEL_CUSTOM_EVENT: NAV_JEWEL_CUSTOM_EVENT
  }
};
var _default = NAV_DATA;
exports.default = _default;